import { CartesianGrid, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export interface PuntoCurvaGrafico {
  /** Posición en el eje del tiempo (cualquier número creciente: días desde una fecha fija). */
  t: number;
  planificado: number;
  /** `null` = todavía no pasó: la línea real se corta ahí. */
  real: number | null;
}

export interface GraficoCurvaProps {
  etiqueta: string;
  puntos: PuntoCurvaGrafico[];
  /** Posición de hoy en el eje; se marca con una línea vertical. */
  hoy?: number;
  formatValor: (valor: number) => string;
  formatEje: (t: number) => string;
}

const COLOR_REAL = "#a44f2f"; // --color-primario
const COLOR_PLAN = "#6b6359"; // --color-texto-suave
const COLOR_GRILLA = "#e3ddd2"; // --color-borde

/** Curva de avance: planificado (punteada) contra real, de 0 a 100 %. Siempre acompañarla con una tabla de los
 *  mismos datos (es la vista accesible con los números). */
export function GraficoCurva({ etiqueta, puntos, hoy, formatValor, formatEje }: GraficoCurvaProps) {
  return (
    <figure className="flex flex-col gap-3">
      <ul aria-label="Referencias" className="flex flex-wrap gap-x-4 gap-y-1 text-chico text-texto-suave">
        <li className="flex items-center gap-1.5">
          <span aria-hidden className="w-5 border-t-2 border-dashed" style={{ borderColor: COLOR_PLAN }} />
          Planificado
        </li>
        <li className="flex items-center gap-1.5">
          <span aria-hidden className="w-5 border-t-2" style={{ borderColor: COLOR_REAL }} />
          Real
        </li>
      </ul>
      <div role="img" aria-label={etiqueta} className="h-60 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={puntos} margin={{ top: 8, right: 12, bottom: 0, left: 0 }}>
            <CartesianGrid stroke={COLOR_GRILLA} strokeDasharray="2 4" vertical={false} />
            <XAxis dataKey="t" type="number" domain={["dataMin", "dataMax"]} tickFormatter={formatEje} tick={{ fontSize: 12 }} minTickGap={32} />
            <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} width={36} tick={{ fontSize: 12 }} />
            <Tooltip formatter={(valor) => formatValor(Number(valor))} labelFormatter={(t) => formatEje(Number(t))} />
            {hoy !== undefined && <ReferenceLine x={hoy} stroke={COLOR_PLAN} label={{ value: "hoy", position: "insideTopRight", fontSize: 12 }} />}
            <Line type="linear" dataKey="planificado" name="Planificado" stroke={COLOR_PLAN} strokeWidth={2} strokeDasharray="6 4" dot={false} isAnimationActive={false} />
            <Line type="linear" dataKey="real" name="Real" stroke={COLOR_REAL} strokeWidth={2.5} dot={{ r: 3 }} connectNulls={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </figure>
  );
}
